import { ElementRef } from "@angular/core";
import { Input } from "@angular/core";
import { Directive } from "@angular/core";

@Directive({
  selector: "[loadingButton]",
})
export class LoadingButtonDirective {
  loadingElement;
  nativeElement: any;

  constructor(private el: ElementRef) {
    this.nativeElement = el.nativeElement;
    this.loadingElement = document.createElement("i");
    this.loadingElement.classList.add("fas");
    this.loadingElement.classList.add("fa-spinner");
    this.loadingElement.classList.add("fa-spin");
    this.loadingElement.style["margin-left"] = "4px";
  }

  @Input()
  set loadingButton(loadingButton: boolean) {
    console.log("set loading button", loadingButton);
    if (loadingButton) {
      console.log("child added");
      this.nativeElement.setAttribute("disabled", "");
      this.nativeElement.appendChild(this.loadingElement);
    } else {
      console.log("remove attribute disabled");
      this.nativeElement.removeAttribute("disabled");
      if (this.loadingElement.parentNode == this.nativeElement) {
        this.nativeElement.removeChild(this.loadingElement);
      }
    }
  }
}
